import legacyAPI from 'apis/helpers/legacyAPI'

const { APP_ENV } = process.env
const isDev = APP_ENV === 'local'
// Helper for LOCAL uploads, `local.saatchiart.com` does NOT exist ( so point to QA )
const URL = isDev ? `/easel_api/localToQA` : ``

async function genericImageUploadAPI(file: File, url: string): Promise<Record<string, any>> {
  const formData = new FormData()
  formData.append('file', file)
  const formOptions = {
    body: formData,
    method: 'POST',
  }
  const json = await legacyAPI.fetchJSON({
    name: 'stageImage',
    formOptions,
    url,
  })
  return json
}

export function stageArtworkImage(file: File): Promise<Record<string, any>> {
  return genericImageUploadAPI(file, `${URL}/art/update/stageextraimage`)
}

export function artAdvisoryImageUploader(file: File): Promise<Record<string, any>> {
  return genericImageUploadAPI(file, `${URL}/artadvisory/upload-image`)
}

export async function updateArtworkImages(params: {
  files: Array<Record<string, any>>
  artworkId: number
}): Promise<Record<string, any>> {
  const { files, artworkId } = params
  const formData = new FormData()
  formData.append('id_user_art', String(artworkId))
  files.forEach((file, index) => {
    const { s3key, description, prefix } = file

    if (file.is_staging) {
      // New
      formData.append(`extra_images[${index}][s3key]`, s3key)
      formData.append(`extra_images[${index}][is_staging]`, '1')
    } else {
      // Existing
      formData.append(`extra_images[${index}][prefix]`, prefix)
    }

    if (description) {
      // Optional
      formData.append(`extra_images[${index}][description]`, description)
    }
  })
  formData.append('extra_images_length', String(files.length))
  const formOptions = {
    body: formData,
    method: 'POST',
  }
  const json = await legacyAPI.fetchJSON({
    name: 'stageImage',
    formOptions,
    url: '/art/update/extraimages',
  })
  return json
}
